import * as S from './styles'
import { useHowWeDo } from './useHowWeDo'
import { Text } from '@/components'
import { useIsVisibleElement } from '@/hooks'
import { HowWeDo } from '@/service/api/culturePage/types'

export type HowWeDoProps = {
  data: HowWeDo
}
export const HowWeDoContainer: React.FC<HowWeDoProps> = ({ data }) => {
  const { fontSizes } = useHowWeDo()

  const { element, elementVisible } = useIsVisibleElement()

  return (
    <S.HowWeDoContainer>
      <Text size={fontSizes.title} color="black" align="center">
        {data.title}
      </Text>
      {data.topics.length > 0 && (
        <div className="topics">
          {data.topics.map((topic, index) => (
            <div
              key={topic.title}
              className="topic"
              ref={index + 1 === data.topics.length ? element : null}
            >
              <Text size={fontSizes.subtitle} color="black" className="title">
                {topic.title}
                <S.Bar color={topic.color} elementIsVisible={elementVisible} />
              </Text>
              <Text size={fontSizes.description} color="gray">
                {topic.description}
              </Text>
            </div>
          ))}
        </div>
      )}
    </S.HowWeDoContainer>
  )
}
